import useTicketOverviewContext from 'components/Ticket/TicketsContainers/useTicketOverviewContext';

export const useTicketActionCallbacks = () => {
  const { actionCallbacks } = useTicketOverviewContext();

  return {
    ...actionCallbacks
  };
};
